import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21217634"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__title" }, " Добро пожаловать ", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__subtitle" }, " Для продолжения работы на сайте укажите дополнительную информацию ", -1 /* HOISTED */))
const _hoisted_3 = { class: "flat-form" }
const _hoisted_4 = {
  key: 0,
  class: "system-alert danger"
}
const _hoisted_5 = { class: "system-alert__wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "help-block"
}
const _hoisted_7 = {
  key: 0,
  class: "help-block"
}
const _hoisted_8 = { class: "auth-form__confirm" }
const _hoisted_9 = { class: "custom-checkbox" }
const _hoisted_10 = { for: "conditions" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_12 = {
  href: "/rules/agreement",
  target: "_blank"
}
const _hoisted_13 = { class: "custom-checkbox" }
const _hoisted_14 = { for: "personalData" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/rules/agreement/persdate",
  target: "_blank"
}, "Согласие на обработку персональных данных", -1 /* HOISTED */))
const _hoisted_17 = { class: "custom-checkbox" }
const _hoisted_18 = { for: "privacyPolicy" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/rules/personal-date",
  target: "_blank"
}, "Политикой конфиденциальности ", -1 /* HOISTED */))
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      ($data.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString($data.error), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["form-group field-firstname", $data.inputErrors?.firstName ? 'has-error' : ''])
      }, [
        _withDirectives(_createElementVNode("input", {
          id: "firstname",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.firstName) = $event)),
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.check && $options.check(...args))),
          type: "text",
          class: "form-control",
          name: "firstName",
          placeholder: "Имя",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($options.onConfirm()), ["enter"]))
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $data.firstName]
        ]),
        ($data.inputErrors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($data.inputErrors.firstName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["form-group field-lastname", $data.inputErrors?.lastName ? 'has-error' : ''])
      }, [
        _withDirectives(_createElementVNode("input", {
          id: "lastname",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.lastName) = $event)),
          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.check && $options.check(...args))),
          type: "text",
          class: "form-control",
          name: "lastName",
          placeholder: "Фамилия",
          onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => ($options.onConfirm()), ["enter"]))
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $data.lastName]
        ]),
        ($data.inputErrors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($data.inputErrors.lastName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              id: "conditions",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.arrayChecked) = $event)),
              value: 1,
              type: "checkbox",
              name: "conditions",
              checked: "",
              onChange: _cache[7] || (_cache[7] = ($event: any) => ($options.check($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelCheckbox, $data.arrayChecked]
            ]),
            _hoisted_11,
            _createTextVNode(" Принимаю "),
            _createElementVNode("a", _hoisted_12, "Условия использования портала \"" + _toDisplayString($options.configuration.projectName) + "\"", 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              id: "personalData",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.arrayChecked) = $event)),
              value: 2,
              type: "checkbox",
              name: "personalData",
              checked: "",
              onChange: _cache[9] || (_cache[9] = ($event: any) => ($options.check($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelCheckbox, $data.arrayChecked]
            ]),
            _hoisted_15,
            _createTextVNode(" Даю "),
            _hoisted_16
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              id: "privacyPolicy",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.arrayChecked) = $event)),
              value: 3,
              type: "checkbox",
              name: "privacyPolicy",
              checked: "",
              onChange: _cache[11] || (_cache[11] = ($event: any) => ($options.check($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelCheckbox, $data.arrayChecked]
            ]),
            _hoisted_19,
            _createTextVNode(" Ознакомлен с "),
            _hoisted_20
          ])
        ])
      ]),
      _createElementVNode("button", {
        id: "signUpConfirm",
        disabled: $data.disabled,
        class: _normalizeClass(["auth-form__btn button button-primary", {'button-loading': this.loading}]),
        onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.onConfirm()))
      }, "Продолжить", 10 /* CLASS, PROPS */, _hoisted_21),
      _createElementVNode("a", {
        class: "auth-form__back",
        onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.onCancel()))
      }, "Отмена")
    ])
  ], 64 /* STABLE_FRAGMENT */))
}